<template>
  <div class="alerts-block">
    <CreateAlertModal @createAlert="createAlert" ref="modal" />
    <AttentionModal
      :attention-visible="attentionVisible"
      @close-modal="attentionVisible = false"
    />
    <div class="attention">
      <p>
        <b>Пожалуйста, будьте внимательны!</b> Этот раздел предназначен для
        отправки уведомлений в личный кабинет пользователей сервиса
        «Квартплата.Онлайн». Для этого введите сообщение в форму ниже и выберите
        подходящий вариант – можно отправить его как отдельным пользователям,
        так и сразу всем жителям обслуживаемых Вами домов.
      </p>
      <p>
        Эта форма НЕ подойдёт, если Вам нужно задать вопрос технической
        поддержке. Чтобы связаться с нами, оставьте заявку в ПК «АРКУС»,
        напишите на почту support@jfservice.ru , или позвоните по номеру
        телефона 8 (861) 240-07-80
      </p>
    </div>
    <div class="left-part">
      <el-input
        prefix-icon="el-icon-search"
        placeholder="Поиск"
        v-model="filterQuery"
        @input="debounceSearch"
        clearable
      />
      <Groups
        ref="groupsRef"
        :messageGroupId="messageGroupId"
        :nameFilter="nameFilter"
        @showChart="messageGroupId = $event"
      />
    </div>
    <div class="right-part">
      <el-button
        style="width: 200px; align-self: end"
        @click="$refs['modal'].showModal()"
      >
        Опубликовать сообщение
      </el-button>

      <Chart
        ref="chartRef"
        :messageGroupId="messageGroupId"
        @refresh="refresh"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CreateAlertModal from "./components/CreateAlertModal.vue";
import Chart from "./components/Chart.vue";
import AttentionModal from "./components/AttentionModal.vue";
import Groups from "./components/Groups.vue";

export default {
  components: {
    CreateAlertModal,
    Chart,
    Groups,
    AttentionModal
  },
  data() {
    return {
      attentionVisible: false,
      dialogVisible: false,
      messageGroupId: null,
      filterQuery: "",
      nameFilter: "",
      searchTimeout: null
    };
  },
  computed: {
    ...mapGetters(["getOrganizationInfo"])
  },
  methods: {
    async createAlert(e) {
      try {
        const result = await this.$store.dispatch("createAlert", e);
        await this.$refs["groupsRef"].loadData();
        if (this.messageGroupId === result) {
          this.$refs["chartRef"].clearState();
          this.$refs["chartRef"].loadMessages();
        } else {
          this.messageGroupId = result;
        }
        if (e.accountIds.length === 0) {
          this.attentionVisible = true;
        }
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
    },
    refresh() {
      this.$refs["groupsRef"].loadData();
    },
    debounceSearch(query) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.nameFilter = query;
      }, 1000);
    }
  }
};
</script>
<style scoped>
.alerts-block {
  display: grid;
  height: 768px;
  grid-template-columns: 300px 1fr;
  grid-template-rows: 170px 600px;
  gap: 0 1em;
}
.attention {
  grid-column-start: 1;
  grid-column-end: 3;
  line-height: 1.5em;
}
.left-part {
  display: flex;
  flex-direction: column;
}
.right-part {
  display: flex;
  flex-direction: column;
}
b {
  color: #f56c6c;
}
</style>
